import { MenuItemModel } from "../models/menu-item";
import { procedimiento2, procedimiento4,procedimiento8 } from "./procedimientos";
import  * as proc from "./procedimientos";
import { rellenarMenUsuario, rellenarMenuAdmin } from "./procedimientos_registros";


export var menuItemDataUser: MenuItemModel[] = rellenarMenUsuario();

/* export var menuItemDataUser: MenuItemModel[] = [
    {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false },
    {id: 'tiritas', icon: 'fa band-aid', text: 'Tiritas',description:'Control de tiritas' ,isSelected: false, ruta: 'tiritas'},
    {id: 'proceso_desverdizacion_etileno', icon: 'fa band-aid', text: 'RE.07.02 Control proceso desverdización: etileno',description:'RE.07.02 Control proceso desverdización: etileno' ,isSelected: false, ruta: 'proceso_desverdizacion_etileno'},
  
    {id: 'control', icon: 'fa band-aid', text: 'Cristales',description:'Control de cristales, plásticos, luces y metales',isSelected: false, ruta: 'control'},
    {id: 'limpieza', icon: 'fa band-aid', text: 'Limpieza',description:'Control de limpieza y desinfección' ,isSelected: false, ruta: 'limpieza'},
    {id: 'inspeccion_recoleccion_citricos', icon: 'fa band-aid', text: 'RE.08.04 Inspección recolección cítricos',description:'RE.08.04 Inspección recolección cítricos' ,isSelected: false, ruta: 'inspeccion_recoleccion_citricos'},
    {id: 'instrumentos_afilados', icon: 'fa band-aid', text: 'RE.18.09 Verificación instrumentos afilados metal',description:'RE.18.09 Verificación instrumentos afilados metal', isSelected: false, ruta: 'instrumentos_afilados'},
    {id: 'parametro', icon: 'fa band-aid', text: 'Parámetros', description:'Control de parámetros en cámaras frigoríficas',isSelected: false, ruta: 'parametro'},
    {id: 'pesos', icon: 'fa band-aid', text: 'Peso pitufo', description:'Registro de control de pesos pitufo',isSelected: false, ruta: 'pesos'},
    {id: 'girsac', icon: 'fa band-aid', text: 'Peso girsac', description:'Registro de control de pesos girsac',isSelected: false, ruta: 'girsac'},
    {id: 'zumos', icon: 'fa band-aid', text: 'Zumos', description:'Registro de control de zumos',isSelected: false, ruta: 'zumos'},
    {id: 'etiquetas', icon: 'fa band-aid', text: procedimiento4.reg.seis.text, description: procedimiento4.reg.seis.text ,isSelected: false, ruta: 'etiquetas'},
    {id: 'test_de_vida_comercial', icon: 'fa band-aid', text: 'RE.08 Test de vida comercial (encajado)', description:'Test de vida comercial',isSelected: false, ruta: 'test_de_vida_comercial'},
    {id: 'test_vida_comercial_mallas', icon: 'fa band-aid', text: 'RE.08 Test de vida comercial (malla)', description:'Test de vida comercial',isSelected: false, ruta: 'test_vida_comercial_mallas'},
    {id: 'control-de-conformidad', icon: 'fa band-aid', text: 'Conformidad', description:'CONTROL DE CONFORMIDAD',isSelected: false, ruta: 'control-de-conformidad'},
    {id: 'transporte_higiene', icon: 'fa band-aid', text: 'RE.07.20 Control higiene transporte', description:'RE.07.20 Control higiene transporte',isSelected: false, ruta: 'transporte_higiene'},
    {id: 'transporte-rutas', icon: 'fa band-aid', text: 'Transporte rutas', description:'TRANSPORTE RUTAS',isSelected: false, ruta: 'transporte-rutas'},
    {id: 'mantenimiento-camiones', icon: 'fa band-aid', text: 'Camiones', description:'MANTENIMIENTO CAMIONES',isSelected: false, ruta: 'mantenimiento-camiones'},
    {id: 'agua_cloro', icon: 'fa band-aid', text: 'RE.07.16 Control del cloro libre de residual del agua', description:'Control del cloro libre de residual del agua',isSelected: false, ruta: 'agua_cloro'},
    {id: 'agua', icon: 'fa band-aid', text: 'Agua', description:'AGUA',isSelected: false, ruta: 'agua'},
    {id: 'control_l_d_expedicion', icon: 'fa band-aid', text: 'RE.07.15 Control L+D expedición', description:'RE.07.15 Control L+D expedición',isSelected: false, ruta: 'control_l_d_expedicion'},
    {id: 'control_l_d_produccion', icon: 'fa band-aid', text: 'RE.07.15 Control L+D producción', description:'RE.07.15 Control L+D producción',isSelected: false, ruta: 'control_l_d_produccion'},
    {id: 'control_l_d_recepcion', icon: 'fa band-aid', text: 'RE.07.15 Control L+D recepción MMPP', description:'RE.07.15 Control L+D recepción MMPP',isSelected: false, ruta: 'control_l_d_recepcion'},
    {id: 'encerado', icon: 'fa band-aid', text: 'Encerado', description:'ENCERADO',isSelected: false, ruta: 'encerado'},
    {id: 'lavadora', icon: 'fa band-aid', text: 'Lavadora', description:'LAVADORA',isSelected: false, ruta: 'lavadora'},
    {id: 'etileno', icon: 'fa band-aid', text: 'Etileno', description:'ETILENO',isSelected: false, ruta: 'etileno'},
    {id: 'nebulizador', icon: 'fa band-aid', text: 'Nebulizador', description:'NEBULIZADOR',isSelected: false, ruta: 'nebulizador'},
    {id: 'cuaderno_campo', icon: 'fa band-aid', text: 'Cuaderno de campo', description:'CUADERNO DE CAMPO',isSelected: false, ruta: 'cuaderno_campo'},
    {id: 'confecciones_diarias', icon: 'fa band-aid', text: 'Confección diarias', description:'CONFECCIONES DIARIAS',isSelected: false, ruta: 'confecciones_diarias'},
    {id: 'plagas', icon: 'fa band-aid', text: 'Plagas', description:'Control de plagas',isSelected: false, ruta: 'plagas'},
    {id: 'camaras_etileno', icon: 'fa band-aid', text: 'Cámaras de etileno', description:'Cámaras de etileno',isSelected: false, ruta: 'camaras_etileno'},
    {id: 'residuos_peligrosos', icon: 'fa band-aid', text: 'Residuos peligrosos', description:'Residuos peligrosos',isSelected: false, ruta: 'residuos_peligrosos'},
    {id: 'control_linea_citricos', icon: 'fa band-aid', text: 'RE.08.03 Control de línea cítricos', description:'RE.08.03 Control de línea cítricos',isSelected: false, ruta: 'control_linea_citricos'},
    {id: 'diario_cogida', icon: 'fa band-aid', text: 'Control diario cogida', description:'Control diario cogida',isSelected: false, ruta: 'diario_cogida'},
    {id: 'peso_materia', icon: 'fa band-aid', text: 'Peso entrada materia prima', description:'CONTROL PESO ENTRADA MATERIA PRIMA',isSelected: false, ruta: 'peso_materia'},
    {id: 'perdida_peso_diaria', icon: 'fa band-aid', text: 'Pérdida de peso diaria', description:'Pérdida diaria de peso en la confección',isSelected: false, ruta: 'perdida_peso_diaria'},
    {id: 'perdida_peso_no_pesada', icon: 'fa band-aid', text: 'Materia prima no pesada', description: 'Registro de entrada materia prima no pesada',isSelected: false, ruta: 'perdida_peso_no_pesada'},
    {id: 'contra_incendios', icon: 'fa band-aid', text: 'Contra incendios', description: 'VERIFICACIÓN INSTALACIONES DE PROTECCION CONTRA INCENDIOS (ANUAL- TRIMESTRAL)',isSelected: false, ruta: 'contra_incendios'},
    {id: 'plan_limpieza_desinfeccion', icon: 'fa band-aid', text: 'Plan de limpieza y desinfección', description: 'PLAN DE LIMPIEZA Y DESINFECCIÓN',isSelected: false, ruta: 'plan_limpieza_desinfeccion'},
    {id: 'reuniones', icon: 'fa band-aid', text: 'Reuniones', description: 'REUNIONES ',isSelected: false, ruta: 'reuniones'},
    {id: 'tratamiento_postcosecha_citricos', icon: 'fa band-aid', text: 'RE.07.18 Tratamiento postcosecha-cítricos (online)', description: 'RE.07.18 Tratamiento postcosecha-cítricos (online) ',isSelected: false, ruta: 'tratamiento_postcosecha_citricos'},
    {id: 'formacion', icon: 'fa band-aid', text: 'Formación', description: 'FORMACIÓN ',isSelected: false, ruta: 'formacion'},
    {id: 'tratamiento_no_conformidad', icon: 'fa band-aid', text: 'Tratamiento de las no conformidades', description: 'Tratamiento de las no conformidades ',isSelected: false, ruta: 'tratamiento_no_conformidad'},
    {id: 'control_documentos', icon: 'fa band-aid', text: proc.procedimiento2.reg.uno.text, description: proc.procedimiento2.reg.uno.text ,isSelected: false, ruta: 'control_documentos'},
    {id: 'organigrama_funcional', icon: 'fa band-aid', text: 'Organigrama funcional', description: 'Organigrama funcional',isSelected: false, ruta: 'organigrama_funcional'},
    {id: 'encuesta_higiene', icon: 'fa band-aid', text: 'Encuesta de higiene', description: 'encuesta de higiene',isSelected: false, ruta: 'encuesta_higiene'},
    {id: 'control_drencher', icon: 'fa band-aid', text: 'Control drencher', description: 'Control drencher',isSelected: false, ruta: 'control_drencher'},
    {id: 'limpieza_cajones', icon: 'fa band-aid', text: 'Registro limpieza cajones', description: 'Registro limpieza cajones',isSelected: false, ruta: 'limpieza_cajones'},
    {id: 'control_calidad_interna_citricos', icon: 'fa band-aid', text: 'RE.08.01 Control calidad interna-cítricos', description: 'RE.08.01 Control calidad interna-cítricos',isSelected: false, ruta: 'control_calidad_interna_citricos'},
    {id: 'producto_embolsado', icon: 'fa band-aid', text: 'RE.08.14 Control del peso del producto embolsado cítricos', description: 'RE.08.14 Control del peso del producto embolsado cítricos',isSelected: false, ruta: 'producto_embolsado'},
    {id: 'peso_encajado_producto', icon: 'fa band-aid', text: 'RE.08.13 Control peso del producto encajado', description: 'RE.08.13 Control peso del producto encajado',isSelected: false, ruta: 'peso_encajado_producto'},
 

    
    
     
]; */
 export var menuItemDataAdmin: MenuItemModel[] = rellenarMenuAdmin();
/*  export var menuItemDataAdmin: MenuItemModel[] = [
    {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio' ,description:'Inicio', isSelected: false },
    {
        id: 'anexo_1',
        icon: 'fa band-aid',
        text: procedimiento2.proc.text,
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'control_documentos', fatherId: 'anexo_1', text: procedimiento2.reg.uno.text , isSelected: false 
            },
            {
                id: 'reuniones', fatherId: 'otros', text: 'Anexo III Listado de reuniones', isSelected: false 
            }
        ]
    },
    {
        id: 'anexo_2',
        icon: 'fa band-aid',
        text: 'P.03 LIMPIEZA Y DESINFECCIÓN',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {id: 'limpieza', fatherId: 'anexo_2', text: 'Anexo II Control de limpieza y desinfección', isSelected: false},
          
            {id: 'plan_limpieza_desinfeccion', fatherId: 'anexo_2', text: 'Anexo III Plan de limpieza y desinfección', isSelected: false},
            {id: 'encuesta_higiene', fatherId: 'anexo_2', text: 'Anexo V Encuesta de higiene', isSelected: false},
          
        ]
    },
    {
        id: 'anexo_4',
        icon: 'fa band-aid',
        text: procedimiento4.proc.text,
        description:'Procedimientos',
        isSelected: false,
        expandable: [
            {id: 'etiquetas', fatherId: 'anexo_4', text: procedimiento4.reg.seis.text, isSelected: false},
            {id: 'zumos', fatherId: 'anexo_4', text: 'Anexo I  Ensayo de contenido en zumos e índice y madurez', isSelected: false},
          
            
            {id: 'control-de-conformidad', fatherId: 'anexo_4', text: 'Anexo V Control de conformidad', isSelected: false},
            {id: 'pesos', fatherId: 'anexo_4', text: 'Anexo VII Registro de control de pesos pitufo', isSelected: false},
            {id: 'girsac', fatherId: 'anexo_4', text: 'Anexo VII.bis Registro de control de pesos malla (girsac)', isSelected: false}
          
        ]
        
    },
    {
        id: 'anexo_5',
        icon: 'fa band-aid',
        text: 'P.05 CONTROL DE INFRAESTRUCTURAS, BIENES Y EQUIPOS',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: '', fatherId: '', text: '', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_7',
        icon: 'fa band-aid',
        text: 'P.07 CONTROL DE LA PRODUCCIÓN',
        description:'P.07',
        isSelected: false,
        expandable: [
            {id: 'proceso_desverdizacion_etileno', fatherId: 'anexo_7', text: 'RE.07.02 Control proceso desverdización: etileno', isSelected: false},
            {id: 'tratamiento_postcosecha_citricos_drencher', fatherId: 'anexo_7', text: 'RE.07.05 Tratamiento postcosecha-cítricos drencher', isSelected: false},
            {id: 'control_l_d_expedicion', fatherId: 'anexo_7', text: 'RE.07.15 Control l+d expedición', isSelected: false},
            {id: 'control_l_d_produccion', fatherId: 'anexo_7', text: 'RE.07.15 Control l+d producción', isSelected: false},
            {id: 'control_l_d_recepcion', fatherId: 'anexo_7', text: 'RE.07.15 Control l+d recepción mmpp', isSelected: false},
            {
                id: 'agua_cloro', fatherId: 'anexo_7', text: 'RE.07.16 Control del cloro libre de residual del agua', isSelected: false 
            },
            {
                id: 'tratamiento_postcosecha_citricos', fatherId: 'anexo_7', text: 'RE.07.18 Tratamiento postcosecha-cítricos (online)', isSelected: false 
            },

            {
                id: 'transporte_higiene', fatherId: 'anexo_7', text: 'RE.07.20 Control higiene transporte', isSelected: false 
            },

            {
                id: '', fatherId: '', text: '', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_8',
        icon: 'fa band-aid',
        text: procedimiento8.proc.text,
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'control_calidad_interna_citricos', fatherId: 'anexo_8', text: 'RE.08.01 Control calidad interna-cítricos', isSelected: false 
            },
            {
                id: 'control_linea_citricos', fatherId: 'anexo_8', text: 'RE.08.03 Control de línea cítricos', isSelected: false 
            },
            {id: 'inspeccion_recoleccion_citricos', fatherId: 'anexo_8', text: 'RE.08.04 Inspección recolección cítricos', isSelected: false},
            {id: 'peso_encajado_producto', fatherId: 'anexo_8', text: 'RE.08.13 Control peso del producto encajado ', isSelected: false},
            {id: 'test_de_vida_comercial', fatherId: 'anexo_8', text: procedimiento8.reg.ocho.text +' (encajados)', isSelected: false},
            {id: 'test_vida_comercial_mallas', fatherId: 'anexo_8', text: procedimiento8.reg.ocho.text + ' (malla)', isSelected: false},
     
            {
                id: 'producto_embolsado', fatherId: 'anexo_8', text: procedimiento8.reg.catorce.text, isSelected: false 
            },
            
           
            {
                id: '', fatherId: '', text: '', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_9',
        icon: 'fa band-aid',
        text: 'P.09 FORMACIÓN',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'formacion', fatherId: 'anexo_9', text: 'Anexo IV Control de formación', isSelected: false 
            }
           
        ]
    },
    {
        id: 'anexo_14',
        icon: 'fa band-aid',
        text: 'P.14 NO CONFORMIDADES',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'tratamiento_no_conformidad', fatherId: 'anexo_14', text: 'Anexo I Tratamiento de las no conformidades', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_18',
        icon: 'fa band-aid',
        text: 'P.18 SISTEMA APPCCC',
        description:'P.18',
        isSelected: false,
        expandable: [
            {
                id: 'instrumentos_afilados', fatherId: 'anexo_18', text: 'RE.18.09 VERIFICACIÓN INSTRUMENTOS AFILADOS METAL', isSelected: false 
            },
           
            {
                id: '', fatherId: '', text: '', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_20',
        icon: 'fa band-aid',
        text: 'P.20 GESTIÓN DE RESIDUOS',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'residuos_peligrosos', fatherId: 'otros', text: 'Anexo Gestión de residuos', isSelected: false 
            },
           
        ]
    },
    {
        id: 'otros',
        icon: 'fa band-aid',
        text: 'OTROS',
        description:'otros',
        isSelected: false,
        expandable: [
            
            {
                id: 'tiritas', fatherId: 'otros', text: 'Control de tiritas', isSelected: false 
            },
            
            {
                id: 'control', fatherId: 'otros', text: 'Control de cristales, plásticos, luces y metales', isSelected: false 
            },
          
            {
                id: 'parametro', fatherId: 'otros', text: 'Control de parámetros en cámaras frigoríficas', isSelected: false 
            },
            
            {
                id: 'transporte-rutas', fatherId: 'otros', text: 'Transporte rutas', isSelected: false 
            },
            {
                id: 'mantenimiento-camiones', fatherId: 'otros', text: 'Mantenimiento camiones', isSelected: false 
            },
           
            {
                id: 'agua', fatherId: 'otros', text: 'Control de Agua', isSelected: false 
            },
            {
                id: 'encerado', fatherId: 'otros', text: 'Control de encerado', isSelected: false 
            },
            {
                id: 'lavadora', fatherId: 'otros', text: 'Control de lavadora', isSelected: false 
            },
            {
                id: 'etileno', fatherId: 'otros', text: 'Control de etileno', isSelected: false 
            },
            {
                id: 'nebulizador', fatherId: 'otros', text: 'Control de nebulizador', isSelected: false 
            },
            {
                id: 'cuaderno_campo', fatherId: 'otros', text: 'Cuaderno de campo', isSelected: false 
            },
            {
                id: 'confecciones_diarias', fatherId: 'otros', text: 'Confección diarias', isSelected: false 
            },
            {
                id: 'plagas', fatherId: 'otros', text: 'Control de plagas', isSelected: false 
            },
            {
                id: 'camaras_etileno', fatherId: 'otros', text: 'Cámaras de etileno', isSelected: false 
            },
            
           
            {
                id: 'diario_cogida', fatherId: 'otros', text: 'Control diario cogida', isSelected: false 
            },
            {
                id: 'peso_materia', fatherId: 'otros', text: 'Control peso entrada materia prima', isSelected: false 
            },
            {
                id: 'perdida_peso_diaria', fatherId: 'otros', text: 'Pérdida diaria de peso en la confección', isSelected: false 
            },
            {
                id: 'perdida_peso_no_pesada', fatherId: 'otros', text: 'Registro de entrada materia prima no pesada', isSelected: false 
            },
            {
                id: 'contra_incendios', fatherId: 'otros', text: 'Verificación instalaciones de proteccion contra incendios (anual- trimestral)', isSelected: false 
            },
         
          
            {
                id: 'organigrama_funcional', fatherId: 'otros', text: 'Organigrama funcional', isSelected: false 
            },
            {
                id: 'control_drencher', fatherId: 'otros', text: 'Anexo III Control drencher', isSelected: false 
            },
            {
                id: 'limpieza_cajones', fatherId: 'otros', text: 'Registro limpieza cajones', isSelected: false 
            },
      
          
      
        ]
    },


    
     
];  */
export var menuItemDataLocatec: MenuItemModel[] = [
    {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false },
    {
        id: 'anexo_1',
        icon: 'fa band-aid',
        text: 'PROCEDIMIENTO 1',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            
            {
                id: 'control_documentos', fatherId: 'anexo_1', text: 'Control de documentos', isSelected: false 
            }
      
        ]
    },
    {
        id: 'anexo_2',
        icon: 'fa band-aid',
        text: 'PROCEDIMIENTO 2',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            
            {id: 'limpieza_desinfeccion', fatherId: 'anexo_2', text: 'Limpieza y desinfección -camiones-', isSelected: false},
            {id: 'limpieza', fatherId: 'anexo_2', text: 'Control de limpieza y desinfección', isSelected: false},
            {id: 'plan_limpieza_desinfeccion', fatherId: 'anexo_2', text: 'Plan de limpieza y desinfección', isSelected: false},
          
        ]
    },
    {
        id: 'anexo_4',
        icon: 'fa band-aid',
        text: 'PROCEDIMIENTO 4',
        description:'Procedimientos',
        isSelected: false,
        expandable: [
            {id: 'zumos', fatherId: 'anexo_4', text: 'Registro de control de zumos índice y madurez', isSelected: false},
            {id: 'producto', fatherId: 'anexo_4', text: 'Control de entradas de materia prima', isSelected: false},
            {id: 'test_de_vida_comercial', fatherId: 'anexo_4', text: 'Test de vida comercial', isSelected: false},
            {id: 'control-de-conformidad', fatherId: 'anexo_4', text: 'Control de conformidad', isSelected: false},
            {id: 'etiquetas', fatherId: 'anexo_4', text: 'Control de etiquetas', isSelected: false},
            {id: 'pesos', fatherId: 'anexo_4', text: 'Registro de control de pesos pitufo', isSelected: false},
            {id: 'girsac', fatherId: 'anexo_4', text: 'Registro de control de pesos malla (girsac)', isSelected: false}
          
        ]
    }];